import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import { brandsQuery } from '../../../graph-ql/queries';
import { BrandResponse } from '../../models/brand/brand.response';

@Injectable()
export class BrandService {

  constructor(public apollo: Apollo) {
  }

  brandsQuery$(page: number, itemPerPage: number): Observable<BrandResponse> {
    return this.apollo.query<BrandResponse>({
      query: brandsQuery,
      variables: {
        brandInput: {
          paginationInput: {
            page,
            itemPerPage
          }
        }
      }
    }).pipe(map(result => {

      if (!result.data['getBrands']) {
        return new BrandResponse([], 0);
      }

      return new BrandResponse(result.data['getBrands']['brands'],
       result.data['getBrands']['totalCount']
      );
    }
      ));
  }
}
